import { Group, GroupItem } from "ra-friendsofbabba";
import React, { Fragment, useMemo } from "react";
import {
  Table,
  TableBody,
  TableFooter,
  TableHead,
  Typography,
  makeStyles,
} from "@material-ui/core";

import Head from "./Head";
import WpActivitiesRows from "./WpActivitiesRows";
import WpDeliverablesRow from "./WpDeliverablesRow";
import WpRows from "./WpRows";
import { useTranslate } from "react-admin";

const MONTHS = Array.from(Array(18).keys()).map((number) => number + 1);

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTableCell-root": {
      padding: 0,
      fontSize: 14,
      borderColor: "white",
    },
    "& .MuiTableRow-root": {
      height: 34,
    },
    "& th": {
      borderWidth: 1,
      borderColor: "white",
      borderStyle: "solid",
    },
    "& td": {
      borderWidth: 1,
      borderColor: "white",
      borderStyle: "solid",
    },
  },
  help: {
    padding: theme.spacing(2),
  },
}));

const TableWrapper = ({ wps, from, to }) => {
  const months = MONTHS.filter((month) => month > from && month <= to);
  const classes = useStyles();
  const isEmpty = useMemo(() => wps === null || wps.length === 0, [wps]);
  const translate = useTranslate();
  return (
    <Group>
      <GroupItem lg={12} md={12} sm={12} xs={12}>
        <Table className={classes.root}>
          <TableHead>
            <Head months={months} />
          </TableHead>
          <TableBody>
            {wps?.map((wp, index) => (
              <Fragment key={index}>
                <WpRows wp={wp} index={index} months={months} />
                <WpActivitiesRows wp={wp} indexWp={index} months={months} />
              </Fragment>
            ))}
          </TableBody>
          <TableFooter>
            <WpDeliverablesRow wps={wps} months={months} />
          </TableFooter>
        </Table>
      </GroupItem>
      {isEmpty && (
        <Typography className={classes.help}>
          {translate(`resources.executive-project-wps.messages.empty`)}
        </Typography>
      )}
    </Group>
  );
};
export default TableWrapper;
